import "@/App.css";
import { useEffect } from "react";
import { ReactLenis } from "lenis/react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Landing from "@/pages/Landing";
import CountryPage from "@/pages/CountryPage";
import DueDiligencePage from "@/pages/DueDiligencePage";
import EmployersPage from "@/pages/EmployersPage";
import CandidatesPage from "@/pages/CandidatesPage";
import Admin from "@/pages/Admin";

const BRAND = "DAAB Recruitment";

function TitleManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    let title = `${BRAND} — Verified European Opportunities`;
    if (pathname.startsWith("/admin")) {
      title = `Admin · ${BRAND}`;
    } else if (pathname.startsWith("/due-diligence")) {
      title = `Due Diligence · ${BRAND}`;
    } else if (pathname.startsWith("/employers")) {
      title = `For Employers · ${BRAND}`;
    } else if (pathname.startsWith("/candidates")) {
      title = `For Candidates · ${BRAND}`;
    } else if (pathname.startsWith("/country/")) {
      const name = pathname
        .split("/country/")[1]
        .replace(/-/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase());
      title = `Recruitment in ${name} · ${BRAND}`;
    }
    // Set now and again on the next tick to override any late title injection.
    document.title = title;
    const t = setTimeout(() => (document.title = title), 300);
    return () => clearTimeout(t);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <TitleManager />
      <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
        <div className="App bg-white text-[#0a0a0a]">
          <div className="noise-overlay" aria-hidden="true" />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/country/:slug" element={<CountryPage />} />
            <Route path="/due-diligence" element={<DueDiligencePage />} />
            <Route path="/employers" element={<EmployersPage />} />
            <Route path="/candidates" element={<CandidatesPage />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </div>
      </ReactLenis>
    </BrowserRouter>
  );
}

export default App;
